import React from "react";
import { Code, Cloud, MegaphoneSimple, ChartLineUp } from "@phosphor-icons/react";
import useReveal from "@/hooks/useReveal";

const SERVICES = [
  { icon: Code, label: "Software Products", desc: "Custom SaaS, ERP and portals built for how your team actually works.", tag: "01" },
  { icon: Cloud, label: "Cloud & Hosting", desc: "Managed infrastructure in UAE, EU and India with SLA-backed uptime.", tag: "02" },
  { icon: MegaphoneSimple, label: "Web Development", desc: "Fixed-price marketing sites, blogs and headless commerce fronts.", tag: "03" },
  { icon: ChartLineUp, label: "Digital Marketing", desc: "Full-funnel retainers covering SEO, paid, content and analytics.", tag: "04" },
];

export default function ServicesFour() {
  const ref = useReveal();
  return (
    <section id="services" ref={ref} data-testid="services" className="reveal section border-b border-[color:var(--line)]">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-4">
            <div className="eyebrow">Four ways we help</div>
            <h2 className="font-display font-black text-4xl md:text-5xl leading-[1.02] mt-4">
              One partner for the entire product lifecycle.
            </h2>
          </div>
          <p className="lg:col-span-7 lg:col-start-6 text-neutral-700 text-lg leading-relaxed">
            Most agencies pick a lane. We combine engineering, design, cloud and growth so your product can be
            built, hosted and marketed by the same team — no finger-pointing when things break.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-l border-t border-[color:var(--line)]">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.label}
                data-testid={`service-${s.tag}`}
                className="border-r border-b border-[color:var(--line)] p-8 hover:bg-neutral-50 transition-colors duration-200 group"
              >
                <div className="flex items-center justify-between">
                  <div className="w-11 h-11 border border-[color:var(--ink)] flex items-center justify-center group-hover:bg-[color:var(--brand)] group-hover:border-[color:var(--brand)] group-hover:text-white transition-colors duration-200">
                    <Icon size={22} weight="bold" />
                  </div>
                  <span className="font-mono text-xs text-neutral-400">{s.tag}</span>
                </div>
                <h3 className="mt-6 font-display font-bold text-xl">{s.label}</h3>
                <p className="mt-2 text-neutral-600 text-sm leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
